@let inside = this.inside();

@if (inside) {
  <svg width="24" height="25" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 12.5H4m0 0 6-6m-6 6 6 6" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
  <span class="text">Back</span>
} @else {
  <span class="text">Close</span>
}
